module.exports = __webpack_public_path__ + "static/KlavikaBasic-Light.c77f2edf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/KlavikaBasic-Light.ttf
// module id = 279
// module chunks = 114276838955818